import { ID_TYPE } from '.';
import { AD_FORMAT_RAW_TYPE, AD_FORMAT } from './adformat';
import { SSP_FORMAT_TYPE } from './sspFormat';

export enum INVENTORY_TYPE { // ssp_campaign_type_info
    banner = 1,
    interstitial = 2,
    native = 3,
    rewardVideo = 4,
}; // banner ~~~

interface inventory_base {
    id: ID_TYPE;
    name: string;
    type: INVENTORY_TYPE;
    sspFormat: SSP_FORMAT_TYPE;
}
export interface IINVENTORY_RESPONSE_IN_APP extends inventory_base{
    format_raw: AD_FORMAT_RAW_TYPE[]
}

export interface IINVENTORY_RESPONSE extends IINVENTORY_RESPONSE_IN_APP {
    app_key: ID_TYPE;
}
export interface IINVENTORY extends inventory_base{
    app_key: ID_TYPE;
    format: AD_FORMAT[];
}